import { useCallback, useState } from 'react'
import { adminApi, getAdminToken } from '../api'
import {
  clearChangePasswordDefer,
  deferChangePasswordSession,
  effectiveMustChangePassword,
} from './changePasswordDefer'

export function useMustChangePassword() {
  const [mustChangePassword, setMustChangePassword] = useState(false)

  const applyMustChangePassword = useCallback((serverFlag: boolean) => {
    const show = effectiveMustChangePassword(serverFlag)
    setMustChangePassword(show)
    return show
  }, [])

  const refreshMustChangePassword = useCallback(() => {
    if (!getAdminToken()) {
      setMustChangePassword(false)
      return Promise.resolve(false)
    }
    return adminApi
      .get<{ user: { must_change_password?: boolean } }>('/admin/auth/me')
      .then((r) => applyMustChangePassword(!!r.data.user.must_change_password))
      .catch(() => {
        setMustChangePassword(false)
        return false
      })
  }, [applyMustChangePassword])

  const deferPasswordChange = useCallback(() => {
    deferChangePasswordSession()
    setMustChangePassword(false)
  }, [])

  const completePasswordChange = useCallback(() => {
    clearChangePasswordDefer()
    setMustChangePassword(false)
  }, [])

  return {
    mustChangePassword,
    setMustChangePassword,
    applyMustChangePassword,
    refreshMustChangePassword,
    deferPasswordChange,
    completePasswordChange,
  }
}
